import Button from '../button';
import CancelButton from "../linkButton";

const GenericForm = (props) => {
  const {
    formTitle,
    formClassName,
    submitLabel,
    submitAction,
    cancelAction,
    children,
    disabled
  } = props;

  return (
    <form className={formClassName}>
      <div className='form-header'>
        <div className='form-title'>{formTitle}</div>
      </div>
      <div className='form-body'>
        <div className='form-items'>
          { children }
          <div className='form-buttons'>
            <CancelButton cancelAction={cancelAction}/>
            <Button label={submitLabel} action={submitAction} disabled={disabled}/>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GenericForm;
